var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uploading_image",attrs:{"id":"uploading_image"}})
}
var staticRenderFns = []

export { render, staticRenderFns }